import store from "../store/store";
import { clearLocalStorage, setLocalStorageNewTokenKey } from "../js/oauth";
import axios from "axios";
import { eventBus } from "../main.js";

const getInfo = () => {
  store
    .dispatch("REQUEST_GET_INFO", localStorage.getItem("token-key"))
    .then((response) => {
      localStorage.setItem("expiredStatus", response.data.expiredStatus);
    });
  if (localStorage.getItem("expiredStatus") === "true") {
    store.dispatch("MATCH_INFO", localStorage.getItem("token-setup"));
  }
};

function setSnackBarInfo(text, time, color, location) {
  if (time === undefined) {
    time = 2000;
  }
  return {
    text: text,
    color: color,
    location: location,
    time: time,
  };
}

function DateToString() {
  var pDate = new Date();
  var yyyy = pDate.getFullYear();
  var mm =
    pDate.getMonth() < 9 ? "0" + (pDate.getMonth() + 1) : pDate.getMonth() + 1; // getMonth() is zero-based
  var dd = pDate.getDate() < 10 ? "0" + pDate.getDate() : pDate.getDate();
  var hh = pDate.getHours() < 10 ? "0" + pDate.getHours() : pDate.getHours();
  var min =
    pDate.getMinutes() < 10 ? "0" + pDate.getMinutes() : pDate.getMinutes();
  var ss =
    pDate.getSeconds() < 10 ? "0" + pDate.getSeconds() : pDate.getSeconds();
  return ""
    .concat(yyyy)
    .concat("-")
    .concat(mm)
    .concat("-")
    .concat(dd)
    .concat(" ")
    .concat(hh)
    .concat(":")
    .concat(min)
    .concat(":")
    .concat(ss);
}

// const init = async (path) => {
async function init(path) {
  try {
    /**
     *  init시 일단 이 사용자의 토큰을 확인한다
     *  그리고 로그를 만든다
     */
    const res = await axios({
      url: "/api/info",
      method: "post",
      data: {
        path: path,
      },
      headers: {
        "token-key": localStorage.getItem("token-key"),
      },
    });

    /**
     *  토큰 키가 null이 아니면 로그인 한 사용자라고 볼 수 있다
     */
    if (localStorage.getItem("token-key") !== null) {
      /**
       *   과거 차단 사용자에게 차단이라는 것을 알려주기 위해 추가
       */
      // if (!res.data.blockaStatus) {
      if (res.data.statusCode == 500) {
        const response = await axios({
          url: "/api/match",
          method: "post",
          headers: {
            "token-setup": localStorage.getItem("token-setup"),
          },
        });

        if (response.data.statusCode == 200) {
          setLocalStorageNewTokenKey(response.data, response.headers);
          // localStorage.setItem("token-key", response.headers["new-token-key"]);
          localStorage.setItem("lastLogin", DateToString());
          return true;
        } else {
          clearLocalStorage();
          return false;
        }
      } else {
        return true;
      }
      // } else {
      //   store.commit("SET_SNACKBAR", setSnackBarInfo("사용자 차단 되었습니다."));
      //   clearLocalStorage();
      //   return false;
      // }
    } else {
      /**
       *  토큰 키가 존재하지 않아서 guest로 분류된다
       */
      return "guest";
    }
  } catch (e) {
    console.log(e);
    clearLocalStorage();
    return false;
  }
}

async function conversion(str) {
  try {
    return str.replace(/<[^>]*>/g, "");
  } catch (e) {
    console.log(e);
  }
}

function inputNumberFormat(obj) {
  obj.value = comma(uncomma(obj.value));
}

function comma(str) {
  return str.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
// function comma(str) {
//     str = String(str);
//     return str.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
// }

function uncomma(str) {
  str = String(str);
  return str.replace(/[^\d]+/g, "");
}

/**
 *
 *  애초에 bulletin은 common에 통합으로 되어 있었음
 */

// function bulletin(contents) {
//
//   try {
//
//     if (contents.isNew) {
//
//       store.commit('NEW_CONTENTS', contents);
//       store.commit('OPEN_MODAL', "새 게시물");
//
//
//     } else {
//       if (contents.editable) {
//         store.commit('ADD_CONTENTS', contents);
//         const res = axios({
//             url: "/api/getReply",
//             method: "post",
//             data: {
//               refId: contents.id,
//               sort: contents.sort
//             },
//             headers: {
//               "token-key": localStorage.getItem("token-key")
//             }
//           })
//           .then(res => {
//             // console.log("reply is ", res);
//             store.commit('SET_REPLY', res.data);
//             store.commit('SET_THISID', contents.id);
//             store.commit('OPEN_MODAL', "게시물 수정");
//           })
//
//
//       } else {
//         const res = axios({
//             url: "/api/getReply",
//             method: "post",
//             data: {
//               refId: contents.id,
//               sort: contents.sort
//             },
//             headers: {
//               "token-key": localStorage.getItem("token-key")
//             }
//           })
//           .then(res => {
//             console.log("here is common_function", contents);
//             // console.log("reply is ", res);
//             store.commit('SET_REPLY', res.data);
//             store.commit('SET_THISID', contents.id);
//             store.commit('ADD_CONTENTS', contents);
//             // store.commit('OPEN_MODAL', "게시물 보기");
//
//
//           })
//       }
//
//     }
//     eventBus.$emit('setAuth');
//
//     return true;
//   } catch (e) {
//     console.log(e);
//     return false;
//
//   }
//
// };

// function bulletin(contents) {
//
//   try {
//     if (contents.isNew) {
//       store.commit('NEW_CONTENTS');
//       store.commit('OPEN_MODAL', "새 게시물");
//     } else {
//       store.commit('ADD_CONTENTS', contents);
//       store.commit('OPEN_MODAL', "게시물 수정");
//     }
//     eventBus.$emit('setAuth');
//     return true;
//   } catch (e) {
//     console.log(e);
//     return false;
//
//   }
//
// };
export { getInfo, setSnackBarInfo, conversion, init, inputNumberFormat, comma };
